import { Directive, ElementRef, AfterViewInit } from "@angular/core";

@Directive({
    selector: '[focus-me]',
})
export class FocusMeDirective implements AfterViewInit {

    constructor(private element: ElementRef) {
    }

    ngAfterViewInit(): void {
        this.element.nativeElement.focus();
    }
}